import { useEffect } from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';
import { LocalStorage } from '@/constants';
import { setAuthToken } from '@/utils/auth-token';

const safeDecodeURLParam = (value: string | null) => {
  if (!value) return null;
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch {
    return value.replace(/\+/g, ' ');
  }
};

export const OauthCallback = () => {
  useEffect(() => {
    const handleCallback = async () => {
      const current = new URL(window.location.href);
      const searchParams = current.searchParams;

      const hashParams = new URLSearchParams(window.location.hash.substring(1));

      const token =
        searchParams.get('token') ??
        searchParams.get('access_token') ??
        hashParams.get('token') ??
        hashParams.get('access_token');

      const rawError = searchParams.get('error') ?? hashParams.get('error');
      const rawErrorDescription =
        searchParams.get('error_description') ??
        searchParams.get('message') ??
        hashParams.get('error_description') ??
        hashParams.get('message');

      const error = safeDecodeURLParam(rawError);
      const errorDescription = safeDecodeURLParam(rawErrorDescription);

      if (error) {
        const message = errorDescription || error || 'Erro na autenticação.';
        window.location.href = `/login?authError=true&errorMessage=${encodeURIComponent(message)}`;
        return;
      }

      const fixedPath = current.pathname.replace(/\/{2,}/g, '/');
      if (fixedPath !== current.pathname) {
        current.pathname = fixedPath;
        window.location.replace(current.toString());
        return;
      }

      if (!token) {
        window.location.href = `/login?authError=true&errorMessage=${encodeURIComponent('Token não recebido. Tente novamente.')}`;
        return;
      }

      try {
        setAuthToken(token);

        const redirectAfterLogin = localStorage.getItem(
          LocalStorage.RedirectAfterLogin
        );
        localStorage.removeItem(LocalStorage.RedirectAfterLogin);

        // Let the server decide where to go: a pending MCP OAuth authorization (stored
        // server-side when /oauth/authorize first redirected to /login) takes priority
        // over the page the user was on before starting the Google/Microsoft login.
        window.location.href = redirectAfterLogin
          ? `/login/continue?redirect_to=${encodeURIComponent(redirectAfterLogin)}`
          : '/login/continue';
      } catch {
        window.location.href = `/login?authError=true&errorMessage=${encodeURIComponent('Erro ao processar autenticação.')}`;
      }
    };

    handleCallback();
  }, []);

  return (
    <Stack justifyContent="center" alignItems="center" height="100vh">
      <ContentBox
        textAlign="center"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress sx={{ mb: 2 }} />
        <Typography gutterBottom variant="h2">
          Processando autenticação...
        </Typography>
        <Typography>Aguarde enquanto verificamos suas credenciais.</Typography>
      </ContentBox>
    </Stack>
  );
};
